import { render, staticRenderFns } from "./IShare.vue?vue&type=template&id=c22a99d0&scoped=true&"
import script from "./IShare.vue?vue&type=script&lang=js&"
export * from "./IShare.vue?vue&type=script&lang=js&"
import style0 from "./IShare.vue?vue&type=style&index=0&id=c22a99d0&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c22a99d0",
  null
  
)

export default component.exports